import TileSprite from './tileSprite'

export default class Player extends TileSprite {
  constructor (game, x, y, key, frame) {
    super(game, x, y, key, frame)

    this.anchor.y = 0.5

    this.moving = false
    this.lastDirection = null

    this.setupAnimation()
  }

  update () {
    if (this.lastDirection && !this.moving) {
      this.animations.play(`standing-${DIRECTIONS[this.lastDirection]}`)
      this.lastDirection = null
    }
  }

  registerValues (objectValues) {
    super.registerValues(objectValues)

    this.values.positionValue = objectValues.next()

    this.values.positionValue.set(this.values.position.getIndirect())
  }

  setDirection (direction) {
    this.lastDirection = direction
  }

  move (direction, moveX, moveY) {
    this.moving = true

    this.tileX += moveX
    this.tileY += moveY

    const destX = this.tileX * TILE_WIDTH
    const destY = this.tileY * TILE_HEIGHT
    this.values.position.set(this.hexCoords())

    const animation = this.animations.play(`move-${DIRECTIONS[direction]}`)

    if (!this.lastDirection) {
      animation.next(1)
    }

    this.game.add.tween(this).to({ x: destX, y: destY }, 250, Phaser.Easing.Linear.None, true)
      .onComplete.addOnce(() => {
        this.moving = false
        this.lastDirection = direction
      })
  }

  setupAnimation () {
    const move_constants = {
      start: 1,
      end: 4,
      suffix: '',
      zeroPad: 2,
      frameRate: 5,
      loop: true
    }

    const standing_constants = {
      start: 1,
      end: 1,
      suffix: '',
      zeroPad: 2,
      frameRate: 0,
      loop: false
    }

    for (let d in DIRECTIONS) {
      this.addFrames(
        Object.assign({ name: `move-${ DIRECTIONS[d] }`, prefix: `sloth-${ DIRECTIONS[d] }-` }, move_constants)
      )

      this.addFrames(
        Object.assign({ name: `standing-${ DIRECTIONS[d] }`, prefix: `sloth-${ DIRECTIONS[d] }-` }, standing_constants)
      )
    }
  }

  addFrames (settings) {
    const frameNames = Phaser.Animation.generateFrameNames(
      settings['prefix'],
      settings['start'],
      settings['end'],
      settings['suffix'],
      settings['zeroPad']
    )

    this.animations.add(
      settings['name'],
      frameNames,
      settings['frameRate'],
      settings['loop']
    )
  }
}
